import { getPriceDecimals } from "../../config/tokens";
import { getContractPriceStepPrecision } from "../../utils/instruments";

const chainId = process.env.REACT_APP_CHAIN_ID;

/** Get price precision with token config override. */
export const getConfigPricePrecision = (
  asset: string,
  amountStep?: string,
  priceStep?: string
): number | undefined => {
  if (chainId) {
    const configDecimals = getPriceDecimals(chainId, asset);
    if (configDecimals !== undefined) return configDecimals;
  }
  if (amountStep && priceStep) {
    return getContractPriceStepPrecision(amountStep, priceStep).price_precision;
  }
  return undefined;
};
